// @flow

type Args = {|
  savedJobs?: SavedJobs,
  jobId: number
|};

type JobStatusFlags = {|
  isSaved: boolean,
  isApplied: boolean
|};

type JobStatus = 'saved' | 'applied' | void;

const getJobStatus = (args: Args): JobStatus =>
  args.savedJobs && args.savedJobs[args.jobId];

export const getJobStatusFlags = (args: Args): JobStatusFlags => ({
  isSaved: getJobStatus(args) === 'saved',
  isApplied: getJobStatus(args) === 'applied'
});
